import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/sections/Footer";
import BlogPostContent from "@/components/blog/BlogPostContent";
import { getPostBySlug } from "@/content/blog";

const BlogPost = () => {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <Navigation />
      <main className="pt-24 md:pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {post ? (
            <BlogPostContent {...post} />
          ) : (
            <div className="text-center text-gray-400">
              Blog post not found
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPost;
